module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-003"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("RAHAB HIDES THE SPIES"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Joshua+2%3A1-7&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("JOSHUA 2:1-7")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The historical account of Joshua’s sending of two spies was visibly fulfilled through John the Baptist, God’s messenger, who preached repentance to prostitutes and publicans (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("). According to another interpretation, this event spiritually signifies Jesus’ sending of two messengers, Peter and Paul, in order to lead his people into the gospel (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). Still another interpretation maintains that the two spies symbolize two commands: to love God and neighbor (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v("). By receiving the spies, Rahab prefigures the church: the harlot was no longer a prostitute, as we are not in our own hearts when we cease to live according to the flesh (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(", G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LVIRA")]), _vm._v("). As her name means “pride,” Rahab typifies the church, which transforms the prideful into the humble (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(", C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIODORUS")]), _vm._v("). Rahab’s lie, like all lies, is unjust. It is her benevolence and not her deception that is rewarded (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). Scripture recalls Rahab’s immorality. Yet it is for her lie that she is found deserving of eternal blessing (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIAN")]), _vm._v("). Her repentance and faith, demonstrated by her lie that safeguarded the sacred, ensured her salvation. Even more so will ours (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v("). She hid the spies on the roof, signifying the loftiness of her faith, and covered them with flax, in order that it would be purified (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-017"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("2:1-2 ")])]), _vm._v("Joshua Sends Out Spies")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSENGERS OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD")]), _vm._v(". ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Meanwhile, the spies are sent by Jesus [Joshua] to Jericho and are received by the prostitute Rahab. Those spies, who are sent before the face of Jesus [Joshua], can also be considered the messengers of God, just as it is written, “Behold, I send my messenger before your face who will prepare your paths.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN62",
      "id": "ap_part1_NFIN62-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" This passage, fulfilled invisibly through others, was fulfilled visibly through John, about whom this was also written. Because the scribes and Pharisees did not believe him, the Lord spoke concerning the baptism of John and said that the “prostitutes and publicans who believed”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN63",
      "id": "ap_part1_NFIN63-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" were baptized. The same thing is fulfilled in the fact that the prostitute received the spies of Jesus [Joshua] and is snatched away and brought back from the destruction of every hostile nation. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 3.3."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN64",
      "id": "ap_part1_NFIN64-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESSENGERS")]), _vm._v(". ")]), _vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": We have been following so far the historical interpretation, and you perceive how from the history itself we are ascending upward gradually to a mystical understanding. Jesus [Joshua], the leader, who had led the people out of Egypt; Jesus [Joshua], whose name means Savior, after the death and burial of Moses in the land of Moab in the land of Arabia—that is, after the law was dead—Jesus desires to lead his people into the gospel and sends out two men on secret mission to Jericho. Two messengers he sends: one to the circumcised; the other to the Gentiles, Peter and Paul. Jericho seeks to kill them; the harlot takes them in, meaning, of course, the church gathered together from the Gentiles. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 18 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 86)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN65",
      "id": "ap_part1_NFIN65-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WO")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMANDS")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AESARIUS OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLES")]), _vm._v(": Moreover, Joshua sends two spies to the city of Jericho, and they are received by a harlot. Joshua sent two spies because the true Joshua was going to give two commands of love. In truth, what else do the men whom the true Joshua sends announce to us except that we should love God and our neighbor? S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON")]), _vm._v(" 115.2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN66",
      "id": "ap_part1_NFIN66-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONGER A")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSTITUTE")]), _vm._v(". ")]), _vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": Nevertheless, our Jesus [Joshua] sends spies to the king of Jericho, and they are received hospitably by a prostitute. But the prostitute who received the spies sent by Jesus [Joshua] was no longer a prostitute since she received them. Indeed, everyone of us was a prostitute in his heart as long as he lived according to the desires and lusts of the flesh. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSHUA")]), _vm._v(" 1.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN67",
      "id": "ap_part1_NFIN67-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSTITUTE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEWED FROM")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY")]), _vm._v(".")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY OF")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LVIRA")]), _vm._v(": “And Joshua the son of Nun,” it says, “sent two spies from Shittim, saying to them ‘Go up and survey the land and Jericho.’ When they arrived in Jericho, the two young men entered the house of a prostitute by the name of Rahab and stayed there as guests.” Pay attention to the structure of this mystery, most beloved brothers, and ask yourselves why men as great as these, for whom the Lord had performed such marvels and miracles, entered the house of a woman of ill repute, as if they were unable to lodge elsewhere. They did this not by chance, I believe, but intentionally by prophetic design. For I find this prostitute in many places, not only as a hostess of saints but also as their bride. The most holy prophet Hosea, for instance, was commanded by the Lord to accept a harlot as his wife: “For the Lord said to me, ‘Take for your wife a prostitute and generate children of prostitution.’ ”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN68",
      "id": "ap_part1_NFIN68-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Even our Lord and Savior himself, when he had sat down by the well in Samaria, conversed with an immoral woman to whom no one had previously spoken there. After he said to her, “You have had five husbands and the one you have now is not your husband,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN69",
      "id": "ap_part1_NFIN69-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" she believed that he was the Messiah, that is, she confessed him to be the Christ. Then there was the harlot who washed the Savior’s feet with her tears and wiped them with her hair and anointed them while kissing them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN70",
      "id": "ap_part1_NFIN70-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Let us see, therefore, what our hostess represents. This Rahab, although she is called a prostitute, nevertheless is a sign of the virgin church, considered as a foreshadow of the coming realities at the end of the age, where she alone is preserved to life among all who are perishing. For even when it was said to the prophet Hosea, “Take for your wife a prostitute,” surely then the image of the church as coming from the Gentiles was being prefigured, given that the people were to be gathered from the harlotry of the nations and from prostitution with idols, for, it says, “they prostituted themselves to strange gods.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN71",
      "id": "ap_part1_NFIN71-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Indeed, she is called “the church” because the Greek word "), _c('i', [_vm._v("ecclesia")]), _vm._v(" means “gathering of the people.” And just as the apostle says, “An unfaithful wife is sanctified through her faithful husband,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN72",
      "id": "ap_part1_NFIN72-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" so also is the church, coming from the infidelity of the Gentiles and prostitution with idols, sanctified through the body of Christ, of which we are members, as we learn from the same apostolic author."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN73",
      "id": "ap_part1_NFIN73-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Because the church, as I have often said, gathered from the multitude of Gentiles, was then called a prostitute, therefore the church is found in the figure of Rahab, the hostess of saints. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RACTATES ON THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" 12."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN74",
      "id": "ap_part1_NFIN74-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": Rahab; what is the force of her name? We have been following the historical sense; let us now reflect upon the anagogic"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN75",
      "id": "ap_part1_NFIN75-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" significance of the name. Rahab thus admits of two interpretations: the name may imply either a “broad space” or, better, “pride.” Consider, therefore, its impact. She who formerly walked the broad, spacious road to death,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN76",
      "id": "ap_part1_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" she whose pride was driving her to destruction, was later converted unto humility. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 18 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 86)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN77",
      "id": "ap_part1_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUD")]), _vm._v(".")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIODORUS")]), _vm._v(": Rahab was a harlot who secretly admitted the spies of Joshua when they visited Jericho and let them out by another exit so that they should not be captured. Her name means “pride.” She was converted by "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("God’s generosity and deserved to obtain mercy. She is a type of the church, which takes in souls endangered by the vice of pride, and lets them out into life by another route, the way of humility and patience. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 86.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN78",
      "id": "ap_part1_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-018"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("2:3-5 ")])]), _vm._v("Rahab Lies to the King of Jericho")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERCY")]), _vm._v(", N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YING")]), _vm._v(", I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EWARDED")]), _vm._v(".")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": Therefore, no lie is just. Accordingly, when examples of lying are proposed to us from the sacred Scriptures, either they are not lies but are thought so for not being understood, or, if they are lies, they are not to be imitated because they cannot be just.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As for its being written that God dealt well with the Hebrew midwives"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN79",
      "id": "ap_part1_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" and with Rahab the harlot of Jericho, he did not deal well with them because they lied but because they were merciful to the men of God. And so, it was not their deception that was rewarded, but their benevolence; the benignity of their intention, not the iniquity of their invention. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GAINST")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YING")]), _vm._v(" 15.31-32."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN80",
      "id": "ap_part1_NFIN80-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HROUGH")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECEPTION")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RONICALLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESSING")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASSIAN")]), _vm._v(": This was the case with Rahab. Scripture not only recalls nothing virtuous about her but even speaks of her immorality. Yet for her lie alone, whereby she chose to conceal the spies rather than betray them, she deserved to share an eternal blessing with the people of God. If she had chosen to speak the truth or to be concerned for the safety of her people, there is no doubt that she and her whole household would not have escaped the approaching destruction and that she would not have deserved to be included among those responsible for the Lord’s birth, to be numbered on the roll of the patriarchs, and, through her offspring, to beget the Savior of all."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN81",
      "id": "ap_part1_NFIN81-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFERENCE")]), _vm._v(" 17.17.1-2."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN82",
      "id": "ap_part1_NFIN82-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea "
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAB")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALVATION")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SSURES")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URS")]), _vm._v(". ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRYSOSTOM")]), _vm._v(": “By faith Rahab the prostitute did not perish with those who were disobedient, having received the spies, but she directed their departure by another road.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN83",
      "id": "ap_part1_NFIN83-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" And pay attention to how much wisdom she blended with her prudence. When those sent by the king came and requested the spies, they ask her, “Did men enter in here and come near you?” She answers them, “Yes, they entered in.” First she builds the truth, and then she applies the lie on top. For no lie like this becomes believable unless it first reveals the truth. For this reason all who tell lies probably to be believed, first speak of truths and reveal confessions and later add the lies and things which are questionable. “Spies entered in here and came near you?” “Yes,” she says. If she had said “no” from the beginning, she would have challenged the messengers to investigate. However, “they entered in,” she says, “and they came out and escaped by such and such a road. Pursue them and you will capture them.” O this good lie! O this good fraud, which does not betray the divine but safeguards the sacred! When the mouths of saints preach the repentance that made Rahab worthy of such salvation, for example, Joshua the son of Nun, who shouts in the desert, “Let Rahab the prostitute live”; and Paul, who says, “By faith Rahab the prostitute did not perish with those who were disobedient,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN84",
      "id": "ap_part1_NFIN84-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" will we not receive salvation even more so when we offer to God our repentance? H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPENTANCE AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LMSGIVING")]), _vm._v(" 7.5.17."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN85",
      "id": "ap_part1_NFIN85-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-019"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('span', {
    staticClass: "r"
  }, [_c('b', [_vm._v("2:6 ")])]), _vm._v("Rahab Hides the Spies Under Flax Stalks")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAX")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YMBOLIZES")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URITY")]), _vm._v(", H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVING")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEN")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROKEN")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WISTED AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASHED")]), _vm._v(".")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": “I will be mindful of Rahab,” of Rahab, that harlot who lodged Jesus’ [Joshua’s] secret agents, who lived in Jericho where Jesus [Joshua] had come and had dispatched the two spies. Jericho, that collapsed in seven days, is a type of this world, and as such is determined to kill the secret agents. Because, therefore, Jericho is bent upon "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("killing the spies, Rahab, the harlot, alone received them, lodged them not on the ground floor but in the upper story of the roof—or, in other words, in the sublimity of her faith. She hid them under her stalks of flax. . . .")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("She believes in Jesus, and those whom Jericho is determined to destroy she protects in safety on her own roof. She harbors them on the roof—in the loftiness of her faith—and hides them under the stems of flax. Even though she is a harlot, she covers them with flax.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Flax with much labor and care becomes of dazzling whiteness. You yourselves know that flax grows from the soil and that when it has come forth from the ground, it is black; it has no beauty; it has no use. First, it is pulled up from the ground, broken, then twisted, afterwards washed. Next, it is pounded; finally, combed, and after so much care and hard work, it finally becomes white. Here, then, is the meaning: this harlot took the messengers in and covered them with her flax so that these agents might turn her flax into dazzling whiteness. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 18 (P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" 86).")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#part1_NFIN86",
      "id": "ap_part1_NFIN86-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-098def88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap3.vue
// module id = 87
// module chunks = 0